// ---------------------------------------------------------------------------
// Restaurant rating display
// ---------------------------------------------------------------------------
// ratingAvg / ratingCount / postCount are written by the review callables in
// functions/reviews.js (never by the client) — see applyRatingChange there.
// Everything that shows a rating (card, map pin, restaurant page) goes through
// this so "4.6 · 128 reviews" reads the same everywhere.
// ---------------------------------------------------------------------------

// null when there is nothing to show at all — callers decide what an empty
// place says.
//
// Two separate numbers, shown together as "★ 4.6 · 128 comments":
//   average — from the 1–5 star ratings only, one per person
//   count   — every comment, so it climbs when the same person posts again,
//             the way a comment count does on TikTok or Instagram
// They are not the same measure, so they are not labelled as though they
// were. `average` is null on its own when people have commented and nobody
// has left stars: a count to show, and no average to show with it.
export function ratingSummary(restaurant) {
  const rated = Number(restaurant?.ratingCount) || 0;
  // Every rating arrived on a post, so the comment count can't be lower.
  const count = Math.max(rated, Number(restaurant?.postCount) || 0);
  if (count <= 0) return null;

  const average = rated > 0
    ? Math.min(5, Math.max(1, Number(restaurant.ratingAvg) || 0)).toFixed(1)
    : null;
  const countText = `${count.toLocaleString('en-US')} ${count === 1 ? 'comment' : 'comments'}`;
  const ratedText = `${rated.toLocaleString('en-US')} ${rated === 1 ? 'rating' : 'ratings'}`;

  return {
    average,
    count,
    rated,
    countText,
    label: average
      ? `rated ${average} out of 5 from ${ratedText}, ${countText}`
      : countText,
  };
}
